import { useCallback, useEffect, useRef } from 'react';
import { captureSession, isSessionCurrent } from '../lib/api';

// Each operation is bound to the mounted page and exact account generation.
export default function useAdminOperation() {
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    const invalidate = () => { mounted.current = false; };
    window.addEventListener('bbw:session-change', invalidate);
    return () => { mounted.current = false; window.removeEventListener('bbw:session-change', invalidate); };
  }, []);
  return useCallback(() => {
    const scope = captureSession();
    return () => mounted.current && isSessionCurrent(scope);
  }, []);
}
